export const POSTHOG_EVENT_NAMES = {
  identify: '$identify',
  /*
    we trigger user_logged_in each time the user logs in using a provider.
    provider values: ['email', 'anonymous', 'google.com', 'apple.com', 'verimi']
  */
  user_logged_in: 'user_logged_in',
  user_logged_out: 'user_logged_out',
  /*
    we trigger user_created_account in the onboarding because it's presented once per account,
    always in the beginning when the user creates the account despite if it's anonymous or not
    so we can assume the registration event occurs there.
  */
  user_created_account: 'user_created_account',
  estate_financing_request: 'estate_financing_request',
  estate_contact_cta: 'estate_contact_cta',
  seniors_cta: 'seniors_cta',
  meinplus_logged_in: 'meinplus_logged_in',
  meinverein_logged_in: 'meinverein_logged_in',
  enabled_modules_changed: 'enabled_modules_changed',
  notification_topics_changed: 'notification_topics_changed',
  filters_changed: 'filters_changed',
  bank_changed: 'bank_changed',
  resource_count: 'resource_count_v2', // v2 to ignore corrupted events
  screen: '$screen',
  anonymous_user_creates_account: 'anonymous_user_creates_account', // when an anonymous user converts to a registered user
  push_notification_opened: 'push_notification_opened',
  push_notification_received: 'push_notification_received',
  bookmark_added: 'bookmark_added',
  bookmark_removed: 'bookmark_removed',
  seniorcare_provider_changed: 'seniorcare_provider_changed',
  app_installs_daily: 'app_installs_daily',
  app_crashes_daily: 'app_crashes_daily',
  app_ratings_daily: 'app_ratings_daily',
};

export const POSTHOG_PROPERTY_NAMES = {
  clubs: 'clubs',
  contact_method_options: {
    email: 'email',
    phone: 'phone',
  },
  contact_method: 'contact_method',
  seniorcare_provider_options: {
    hilfsbereit: 'hilfsbereit',
    meinhelfair: 'meinhelfair',
  },
  seniorcare_provider: 'seniorcare_provider',
  seniorcare_region: 'seniorcare_region',
  login_provider: 'login_provider',
  bookmarks: 'bookmarks',
  bank: 'bank',
  bank_object: {
    bic: 'bic',
    name: 'name',
    institute: 'institute',
  },
  homepage: 'homepage',
  notification_topics: 'topics',
  notification: {
    resource_type: 'resource_type',
    topic: 'topic',
    resource_id: 'resource_id',
  },
  modules_with_filters: 'modules_with_filters',
  enabled_modules: 'modules',
  is_deleted: 'is_deleted', // for users who deleted their account in the mobile app
  is_anonymous_user: 'is_anonymous_user',
  user_creation_time: 'user_creation_time', // in ISO format
  resource_id: 'resource_id',
  resource_title: 'resource_title',
  resource_type: 'resource_type',
  resource_feed_type: 'resource_feed_type',
  resource_state: 'resource_state',
  resource_count: 'resource_count',
  resource_creator_group: 'resource_creator_group',
  screen_context: 'screen_context', // to identify the context of the screen, e.g. 'Profile', 'Discovery Map', 'Bank' etc.
  event_start_date: 'event_start_date',
  event_end_date: 'event_end_date',
  event_location: 'event_location',
  event_is_recurring: 'event_is_recurring',
  estate_plz: 'estate_plz',
  estate_reference: 'estate_reference',
  feed_type: 'feed_type',
  offer_partner_id: 'offer_partner_id',
  environment: 'environment', // to identify internal testing
  screen_name: '$screen_name',
  os_name: '$os_name',
  os: '$os',
  other_results: '$$_posthog_breakdown_other_$$',
  null_results: '$$_posthog_breakdown_null_$$',
  installs: 'installs',
  uninstalls: 'uninstalls',
};
